import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "error", "value"]

  connect() {
    // Platzhalter merken, um ihn beim Entfernen der Datei wiederherzustellen.
    if (this.hasValueTarget) {
      this.defaultLabel = this.valueTarget.textContent.trim()
    }
    this.validate()
  }

  validate() {
    const fileInput = this.inputTarget
    if (!fileInput) return

    fileInput.addEventListener('change', (event) => {
      this.validateFile(event.target.files[0])
    })
  }

  checkFileType(event) {
    this.validateFile(event.target.files[0])
  }

  validateFile(file) {
    // Direktes Feedback: ausgewählten Dateinamen anzeigen (bzw. Platzhalter, wenn keine Datei).
    if (this.hasValueTarget) {
      this.valueTarget.textContent = file ? file.name : (this.defaultLabel || this.valueTarget.textContent)
    }

    if (!file) {
      this.hideError()
      return true
    }

    const maxSizeMb = parseInt(this.inputTarget?.dataset?.maxSizeMb || '10', 10)
    const maxSize = maxSizeMb * 1024 * 1024

    // Nur Typ prüfen, wenn die View ein accept-Attribut setzt (sonst z.B. Backend-Anhänge flexibel lassen)
    const rawAccept = this.inputTarget.getAttribute('accept')
    const accept = (rawAccept && rawAccept.trim()) ? rawAccept.toLowerCase() : ''
    const isPdfAccept = accept && accept.includes('application/pdf')
    const isJsonAccept = accept && (accept.includes('application/json') || accept.includes('.json'))

    if (isPdfAccept) {
      const isPdf = file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf')
      if (!isPdf) {
        this.showError('Bitte wählen Sie eine PDF-Datei aus.')
        return false
      }
    } else if (isJsonAccept) {
      const isJson = file.type === 'application/json' || file.name.toLowerCase().endsWith('.json')
      if (!isJson) {
        this.showError('Bitte wählen Sie eine JSON-Datei aus.')
        return false
      }
    }

    if (file.size > maxSize) {
      this.showError(`Die Datei ist zu groß. Maximale Größe: ${maxSizeMb} MB`)
      return false
    }

    if (isJsonAccept) {
      const reader = new FileReader()
      reader.onload = (e) => {
        try {
          JSON.parse(e.target.result)
          this.hideError()
        } catch (e) {
          this.showError(`Ungültige JSON-Datei: ${e.message}`)
        }
      }
      reader.readAsText(file)
      return true
    }

    this.hideError()
    return true
  }

  showError(message) {
    // error-Target ist optional (manche Upload-Widgets haben keins).
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = message
      this.errorTarget.classList.remove('hidden')
    }
    try {
      this.inputTarget.classList.add('border-red-500', 'focus:ring-red-600', 'focus:border-red-600')
    } catch (e) {}
  }

  hideError() {
    if (this.hasErrorTarget) {
      this.errorTarget.classList.add('hidden')
    }
    try {
      this.inputTarget.classList.remove('border-red-500', 'focus:ring-red-600', 'focus:border-red-600')
    } catch (e) {}
  }
}
